
import { supabase } from '@/integrations/supabase/client';

// This function will try to use the edge function first, then fall back to browser generation
export const generateVAPIDKeys = async () => {
  try {
    // First attempt: Try to use the Supabase Edge Function
    const { data, error } = await supabase.functions.invoke('generate-vapid');
    
    if (error) {
      console.error('Error generating VAPID keys with edge function:', error);
      // Fall back to browser-based generation
      return generateKeysInBrowser();
    }

    return data;
  } catch (err) {
    console.error('Unexpected error with edge function:', err);
    // Fall back to browser-based generation
    return generateKeysInBrowser();
  }
};

// Browser-based VAPID key generation
async function generateKeysInBrowser() {
  try {
    // Using the SubtleCrypto API available in modern browsers
    const keyPair = await window.crypto.subtle.generateKey(
      {
        name: 'ECDSA',
        namedCurve: 'P-256'
      },
      true,
      ['sign', 'verify']
    );

    // Export the keys in the required format
    const publicKey = await window.crypto.subtle.exportKey('raw', keyPair.publicKey);
    const privateKey = await window.crypto.subtle.exportKey('pkcs8', keyPair.privateKey);

    // Convert the ArrayBuffers to base64 encoded strings
    const publicKeyBase64 = btoa(String.fromCharCode.apply(null, new Uint8Array(publicKey)));
    const privateKeyBase64 = btoa(String.fromCharCode.apply(null, new Uint8Array(privateKey)));

    // VAPID keys format needs URL-safe base64 with no padding
    const urlSafePublicKey = publicKeyBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    const urlSafePrivateKey = privateKeyBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    console.log('Successfully generated VAPID keys in browser');
    
    return {
      publicKey: urlSafePublicKey,
      privateKey: urlSafePrivateKey
    };
  } catch (err) {
    console.error('Error generating VAPID keys in browser:', err);
    throw new Error('Failed to generate VAPID keys in browser: ' + err.message);
  }
}
